import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Pin } from 'lucide-react';

const announcements = [
  {
    id: 1,
    title: 'Mantenimiento de Elevadores',
    date: 'Mañana, 10:00 - 14:00',
    priority: 'high',
    pinned: true,
  },
  {
    id: 2,
    title: 'Junta de Condominio',
    date: 'Viernes 28, 19:00',
    priority: 'normal',
    pinned: false,
  },
  {
    id: 3,
    title: 'Corte de Agua Programado',
    date: 'Martes 25, 08:00 - 12:00',
    priority: 'high',
    pinned: false,
  },
];

export function AnnouncementsWidget() {
  const navigate = useNavigate();

  return (
    <div className="space-y-3">
      {announcements.map((announcement) => (
        <div
          key={announcement.id}
          className={`p-3 rounded-lg border-l-4 ${
            announcement.priority === 'high'
              ? 'bg-red-50 border-red-400'
              : 'bg-gray-50 border-gray-300'
          }`}
        >
          <div className="flex items-start gap-2">
            {announcement.pinned && (
              <Pin className="w-3 h-3 text-[#36CCD8] mt-1 flex-shrink-0" />
            )}
            <div className="flex-1 min-w-0">
              <p className={`font-medium text-sm truncate ${
                announcement.priority === 'high' ? 'text-red-900' : 'text-gray-900'
              }`}>
                {announcement.title}
              </p>
              <div className="flex items-center gap-1 mt-1 text-xs text-gray-500">
                <Calendar className="w-3 h-3" />
                <span>{announcement.date}</span>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="pt-2 border-t border-gray-100">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-500">Total anuncios:</span>
          <span className="font-semibold text-gray-900">{announcements.length}</span>
        </div>
      </div>

      <button
        onClick={() => navigate('/announcements')}
        className="w-full py-2 text-sm font-medium text-[#36CCD8] hover:text-[#2DB8C4] hover:bg-[#36CCD8]/5 rounded-lg transition-colors"
      >
        Ver todos los anuncios →
      </button>
    </div>
  );
}

export default AnnouncementsWidget;
